import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/publicationService";
const store = {};
const mutations = {
    SET_OPEN_PUBLICATION_LIST(state, posts) {
        state.openPublicationList = posts;
        state.openPublicationListIsLoading = false;
    },
    SET_PUBLICATION_LIST(state, posts) {
        state.publicationList = posts;
        state.publicationListIsLoading = false;
    },
    GET_DETAIL(state, posts) {
        if (posts.success == true) {
            state.publicationDetail = posts.data;
            state.publicationDetailChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
    SAVE_DETAIL(state, posts) {
        if (posts.success == true) {
            state.publicationDetailChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
};
const state = {
    openPublicationListIsLoading: false,
    publicationListIsLoading: false,
    openPublicationList: [],
    publicationList: [],
    publicationDetail: {},
    publicationDetailChanged: false
};
const getters = {};
const actions = {
    getPublicationList({ commit }) {
        state.publicationListIsLoading = true;
        axios
            .get(baseUri + '/GetList')
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_PUBLICATION_LIST', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
   
    savePublicationDetail({ commit }) {
        var formData = new FormData();
        formData.append("data", JSON.stringify(state.publicationDetail));
        axios
            .post(baseUri + '/update', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('UPDATE_DETAIL', res.data);
                } else {
                    alert("An error occured while updating: " + res.data.errorMessage);
                }
            });
    }
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}